package fr.xibalba.generateurClassesLycee.eleves

import fr.xibalba.generateurClassesLycee.expectUpToOne
import fr.xibalba.generateurClassesLycee.mapToPair
import fr.xibalba.generateurClassesLycee.mapToTriple

fun loadEleves(csvData: List<String>, hasHeader: Boolean): Pair<List<Eleve>, List<Int>> {
    val data = if (hasHeader) csvData.drop(1) else csvData // Skip header line
    val errorLines = mutableListOf<Int>()
    val eleves = data.mapIndexedNotNull { index, line ->
        if (line.isBlank() || line.isEmpty()) return@mapIndexedNotNull null // Skip empty lines
        try {
            val parts = line.split(",")
            val nom = parts[0]
            val prenom = parts[1]
            val garcon = parts[2] == "M"
            val type = parts[4]
            val options = parts.slice(8..14).filterNot { it.isBlank() || it.isEmpty() }
            when (type) {
                "PREMIERE GENERALE", "PREMIERE GENERALE EUROPEENNE" -> {
                    ElevePremiereGenerale(nom,
                        prenom,
                        garcon,
                        Langue.fromCode(options.first()) ?: throw IllegalArgumentException("Invalid language code: ${options.first()}"),
                        options.mapNotNull { Specialite.fromCode(it) }.sorted().mapToTriple(),
                        options.mapNotNull { Section.fromCode(it) }.expectUpToOne().firstOrNull()
                    )
                }
                "TERMINALE GENERALE", "TERMINALE GENERALE EUROPEENNE" -> {
                    EleveTerminaleGenerale(nom,
                        prenom,
                        garcon,
                        Langue.fromCode(options.first()) ?: throw IllegalArgumentException("Invalid language code: ${options.first()}"),
                        options.mapNotNull { Specialite.fromCode(it) }.sorted().mapToPair(),
                        options.mapNotNull { Section.fromCode(it) }.expectUpToOne().firstOrNull(),
                        options.mapNotNull { Option.fromCode(it) }.expectUpToOne().firstOrNull()
                    )
                }
                "1STI2D SC. & TECHN. INGEN.INNOV.DEV.DUR.", "1STI2D SC.TEC.INGEN.INNOV.DUR.EUROPEENNE" -> {
                    ElevePremiereTechnologique(nom,
                        prenom,
                        garcon,
                        Langue.fromCode(options.first()) ?: throw IllegalArgumentException("Invalid language code: ${options.first()}"),
                        options.mapNotNull { Section.fromCode(it) }.expectUpToOne().firstOrNull()
                    )
                }
                "TSTI2D ARCHITECTURE CONSTRUCTION", "TSTI2D ENERGIES  ET ENVIRONNEMENT", "TSTI2D INNOV.TECHNO.  ECO CONCEPT.", "TSTI2D SYSTÈME INFO. ET NUMERIQUE" -> {
                    EleveTerminaleTechnologique(nom,
                        prenom,
                        garcon,
                        Langue.fromCode(options.first()) ?: throw IllegalArgumentException("Invalid language code: ${options.first()}"),
                        TypeSTI2D.fromCode(type) ?: throw IllegalArgumentException("Invalid type code: $type"),
                        options.mapNotNull { Section.fromCode(it) }.expectUpToOne().firstOrNull()
                    )
                }
                "TLEPRO TECHNICIEN CONSTRUCTEUR BOIS", "TLEPRO TECHNICIEN MENUISIER AGENCEUR" -> {
                    EleveTerminalePro(nom, prenom, garcon)
                }
                "1BTS2  BATIMENT", "1BTS2  DEVELOPPEMENT ET REALISATION BOIS", "2BTS2  BATIMENT", "2BTS2  CON.PROC.REA.PROD. OPT.B PROD.SER", "2BTS2  CYB.INF.RES.ELEC. OPT.B ELEC.RES.", "2BTS2  DEVELOPPEMENT ET REALISATION BOIS", "2BTS2  MAINTEN.SYST. OPT.A SYST.PRODUCT", "2BTS2  MANAGT. ECONOM. DE LA CONSTRUC.", "2BTS2  SYST. CONSTRUCTIFS BOIS & HABITAT" -> {
                    EleveBTS(nom, prenom, garcon)
                }
                else -> throw NotImplementedError("Type d'élève non implémenté: $type")
            }
        } catch (_: Exception) {
            errorLines += index + if (hasHeader) 1 else 0 // Adjust index if header is present
            null
        }
    }
    return eleves to errorLines
}